import Badges from '@jetshop/ui/ProductList/Badges';
import React, { Component } from 'react';
import { styled } from 'linaria/react';
import Image from '@jetshop/ui/Image';
import Thumbs from './Thumbs';
import { SliderStyles, sliderSettings } from '../../ui/SlickSlider';
import Slider from 'react-slick';
import { BadgeWrapper, imageOverlay } from '../../CategoryPage/ProductCard';
import ImageHandler from './ImageHandler';
import { Above } from '@jetshop/ui/Breakpoints';
import { theme } from '../../Theming/Theming';

const Wrapper = styled('div')`
  position: relative;
  //overflow: hidden;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  ${theme.above.lg} {
    flex-direction: row;
  }
  ${theme.below.sm} {
    .thumbs-wrapper {
      display: none;
    }
  }
`;

const MainSlider = styled('div')`
  position: relative;
  width: 100%;
  order: 1;
  ${theme.above.lg} {
    width: 80%;
    order: 2;
  }
  ${theme.above.md} {
    padding: 0;
  }
  ${theme.below.md} {
    .slick-slider {
      margin: 0 0 !important;
      .slick-slide {
        padding: 0 0 !important;
      }
      .slick-next {
        right: 0;
      }
      .slick-prev {
        right: 14px;
      }
    }
  }
`;

const ImageWrapper = styled('div')`
  cursor: pointer;
  display: block !important;
  &:focus {
    outline: none;
  }
  ${imageOverlay}
`;

export default class ImageSlider extends Component {
  state = {
    activeImage: false,
    activeSliderImage: 0,
    selectedVariationImage: null
  };
  setActiveImage = image => this.setState({ activeImage: image });
  goTo = index => {
    this.imageSlider.slickGoTo(index);
  };
  selectSliderImage = (i, fromThumb) => {
    if (fromThumb) this.goTo(i);
    this.setState({
      activeSliderImage: i
    });
  };
  handleClick = image => {
    this.setActiveImage(image, false);
  };
  componentDidUpdate(prevProps) {
    //GO TO CORRECT VARIATION IMAGE
    if (this.props.selectedVariation !== prevProps.selectedVariation)
      this.variationImage(this.props.images, this.props.selectedVariation);
  }
  variationImage = (images, selectedVariation) => {
    for (let i = 0; i < images.length; i++) {
      if (
        selectedVariation &&
        selectedVariation.images.length &&
        images[i].url === selectedVariation.images[0].url
      ) {
        if (this.state.activeSliderImage !== i) this.selectSliderImage(i, true);
      }
    }
  };
  render() {
    const { images, className, badges } = this.props;
    const { activeImage, activeSliderImage } = this.state;
    return (
      <Wrapper className={className}>
        <MainSlider className="main-wrapper">
          <SliderStyles>
            <Slider
              {...{
                ...sliderSettings,
                speed: 200,
                beforeChange: (current, next) => this.selectSliderImage(next)
              }}
              ref={slider => (this.imageSlider = slider)}
            >
              {images.map((image, index) => (
                <ImageWrapper
                  key={index}
                  onClick={() => {
                    this.handleClick(image);
                  }}
                >
                  <Image
                    src={image.url}
                    sizes={[1, 1, 1, 700]}
                    aspect={theme.productPage.imageAspect}
                    crop={false}
                  />
                </ImageWrapper>
              ))}
            </Slider>
          </SliderStyles>
          <BadgeWrapper>
            <Badges badges={badges} />
          </BadgeWrapper>
        </MainSlider>
        <Above breakpoint="sm">
          {matches => {
            if (matches)
              return (
                <Thumbs
                  images={images}
                  selectSliderImage={this.selectSliderImage}
                  activeSliderImage={this.state.activeSliderImage}
                />
              );
            return null;
          }}
        </Above>
        {activeImage && (
          <ImageHandler
            activeImage={activeImage}
            activeSliderImage={activeSliderImage}
            images={images}
            setActiveImage={this.setActiveImage}
          />
        )}
      </Wrapper>
    );
  }
}
